const orderSelector = {
  order: state => state.orderReducer.order,
  orderBeingFetched: state => state.orderReducer.orderBeingFetched,
  orderLoading: state => state.orderReducer.orderLoading,
  trackingInfo: state => state.orderReducer.trackingInfo,
  trackingInfoLoading: state => state.orderReducer.trackingInfoLoading,
}

export default orderSelector
